import { render } from "./WhatsAppMetaConnectPage.vue?vue&type=template&id=98de6d04&ts=true"
import script from "./WhatsAppMetaConnectPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./WhatsAppMetaConnectPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/whatsapp-meta/WhatsAppMetaConnectPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "98de6d04"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('98de6d04', __exports__)) {
    api.reload('98de6d04', __exports__)
  }
  
  module.hot.accept("./WhatsAppMetaConnectPage.vue?vue&type=template&id=98de6d04&ts=true", () => {
    api.rerender('98de6d04', render)
  })

}


export default __exports__